import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("line", {
				x1: 2,
				y1: 7,
				x2: 22,
				y2: 7
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 2,
				y1: 17,
				x2: 22,
				y2: 17
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 4,
				y1: 5,
				x2: 4,
				y2: 19
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 9.33,
				y1: 5,
				x2: 9.33,
				y2: 19
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 14.67,
				y1: 5,
				x2: 14.67,
				y2: 19
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 20,
				y1: 5,
				x2: 20,
				y2: 19
			})
		]
	})
});
export default SvgRail;
